import BarItem from './barItem';

import './styles.css';

export default function Bars({ 
  bars,
  label,
  maxScore,
  isBigScores,
  alignBarTitle
}) {
  return (
    <ul className={`analysis-bars ${isBigScores ? 'big-scores' : ''}`}> 
      {
        bars.map((barItem, index) => (
          <BarItem
            key={index}
            title={barItem.title}
            score={barItem.score}
            color={barItem.color}
            formattedScore={barItem.score}
            maxScore={maxScore}
            label={label}
            alignBarTitle={alignBarTitle}
            notApplicable={barItem.notApplicable}
          />
        ))
      }
    </ul>
  );
};
